<template>
  <mf-loading-dialog :loading="$apollo.queries.campanha.loading || offerScheduleAndStaticSegmentsLoading">
    <base-page-layout ref="basePage" :title="pageTitle" class="alteracao-whatsapp">
      <title-description
        class="mb-4"
        :title.sync="campanha.title"
        :description.sync="campanha.description"
        :title-error="$v.campanha.title.$error"
        :title-error-message="errorTitle"
        :description-error="$v.campanha.description && $v.campanha.description.$error"
        :status="campanha.status"
        :description-error-message="errorDescription"
      />
      <v-container class="pa-0" fluid>
        <v-row>
          <v-col cols="6" class="d-flex flex-column">
            <whatsapp-message-preview
              ref="whatsappMessagePreview"
              :thumbnail-url="fileProperties && fileProperties.thumbnail_url"
              :file-url="fileProperties && fileProperties.data_url"
              :file-name="fileProperties && fileProperties.filename"
              :file-mimetype="fileProperties && fileProperties.mimetype"
              :message-variables-disabled="messageVariablesDisabled"
              :message="campanha.message"
              :has-optout-message="hasOptoutMessage"
            />
          </v-col>
          <v-col cols="6" class="d-flex flex-column">
            <file-upload-card :file-properties.sync="fileProperties" />

            <v-card class="mb-6 flex-grow-1">
              <v-card-text>
                <v-row class="px-3 pb-3">
                  <h3 class="whatsapp-card-title">
                    Mensagem da campanha
                    <v-tooltip right max-width="300px">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <mf-icon small color="cinza-0" class="ml-1">info</mf-icon>
                        </span>
                      </template>
                      <span>Por padrão, ao final de toda mensagem segmentada será enviada para seus clientes a opção de descadastramento.</span>
                    </v-tooltip>
                  </h3>
                  <v-spacer />
                  <div class="pr-3 d-flex align-center">
                    <message-variables :disabled="messageVariablesDisabled" :tooltip-text="messageVariablesTooltipText" />
                  </div>
                  <template-message-modal v-model="selectedTemplate" :mode="['WHATSAPP']" />
                </v-row>
                <mf-textarea-emoji
                  v-model="campanha.message.text"
                  hide-details
                  class="textarea"
                  :max-length="1000"
                  outlined
                  no-resize
                  rows="4"
                  counter="1000"
                  :error-messages="errorText"
                />
              </v-card-text>
            </v-card>

            <disparadores ref="disparadores" :chosen-senders.sync="chosenSenders" class="flex-grow-1" />
          </v-col>
        </v-row>
      </v-container>
      <v-row>
        <v-col v-if="isOfferSchedulePermissionActive" cols="3" class="d-flex">
          <offer-schedule-card :offer-schedule="offerSchedule" />
        </v-col>

        <v-col :cols="isOfferSchedulePermissionActive ? 9 : 12" class="d-flex flex-column justify-space-between">
          <v-row>
            <v-col cols="12" class="pt-0"
              ><segmentos
                :chosen-segments.sync="chosenSegments"
                :total-contacts="totalSenderContacts"
                :senders="chosenSenders"
                :force-loading="$apollo.queries.totalSenderContacts.loading || initialLoadingContacts"
                :targeting-mode.sync="targetingMode"
                :is-offer-schedule-personalized="isOfferSchedulePersonalized"
                class="mb-6 fill-height"
            /></v-col>
          </v-row>

          <v-row>
            <v-col cols="6" class="pb-0">
              <products-configuration :products.sync="campanha.products" class="mb-6 fill-height" />
            </v-col>
            <v-col cols="6" class="pb-0">
              <units-configuration :selected-units.sync="campanha.units" class="fill-height" :unit-error="$v.campanha.units && $v.campanha.units.$error" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <measuring-and-recurrency v-model="campanha" :validations="$v" :min-time="minSendTime" :max-time="maxSendTime" is-whatsapp-campaign />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <campanhas-agendadas :senders="chosenSenders" :send-date="campanha.message.send_date" />
        </v-col>
      </v-row>

      <v-container fluid class="pa-0">
        <mf-action-buttons
          v-if="campanha.status !== 'SCHEDULED'"
          :primary-button="{
            text: 'Ativar campanha',
            action: () => submit({ isDraft: false, loader: 'draft.submit' }),
            isVisible: true,
            isLoading: $wait.is('draft.submit'),
            isDisabled: $wait.any,
          }"
          :secondary-button="{
            text: 'Salvar rascunho',
            action: () => submit({ isDraft: true, loader: 'draft.submitAsDraft' }),
            isVisible: true,
            isLoading: $wait.is('draft.submitAsDraft'),
            isDisabled: $wait.any,
          }"
          :extra-button="{
            text: 'Apagar rascunho',
            action: () => remove({ loader: 'draft.remove' }),
            isVisible: campanha.status === 'DRAFT',
            isDisabled: $wait.any,
            isLoading: $wait.is('draft.remove'),
          }"
          :cancel-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
            isDisabled: $wait.any,
          }"
        />
        <mf-action-buttons
          v-else
          :primary-button="{
            text: 'Salvar alterações',
            action: () => submit({ isDraft: false, loader: 'scheduled.submit' }),
            isVisible: true,
            isLoading: $wait.is('scheduled.submit'),
            isDisabled: $wait.any,
          }"
          :secondary-button="{
            text: 'Desativar',
            action: () => confirmDisable({ loader: 'scheduled.disable' }),
            isVisible: true,
            isDisabled: $wait.any,
            isLoading: $wait.is('scheduled.disable'),
          }"
          :cancel-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
            isDisabled: $wait.any,
          }"
        />
      </v-container>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import offerScheduleCampaign from '@/modules/campanhas/views/mixins/offer-schedule-campaign.js'
import loadBenefitCampaignMixin from '@/modules/campanhas/cupom-desconto/mixins/load-benefit-campaign.js'
import cloneDeep from 'lodash/cloneDeep'
import Swal from 'sweetalert2'
import BasePageLayout from '@/components/BasePageLayout.vue'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { isFuture, timeIsFuture, notOnlySpace } from '@/helpers/validators.js'
import { mapGetters, mapActions } from 'vuex'
import TemplateMessageModal from '@/components/template-message/TemplateMessageModal.vue'
import {
  QUERY_GET_CAMPAIGN_EDIT_BY_ID,
  MUTATION_UPSERT_CAMPAIGN,
  MUTATION_UPSERT_DRAFT_CAMPAIGN,
  MUTATION_DELETE_CAMPAIGN,
  QUERY_NUMBER_OF_CONTACTS,
} from '@/modules/campanhas/whatsapp/graphql'

export default {
  name: 'AlteracaoCampanhaWhatsapp',
  components: {
    BasePageLayout,
    TitleDescription: () => import('@/modules/campanhas/views/components/edit/TitleDescription.vue'),
    WhatsappMessagePreview: () => import('@/modules/campanhas/whatsapp/views/pages/WhatsappMessagePreview.vue'),
    FileUploadCard: () => import('@/modules/campanhas/whatsapp/views/components/FileUploadCard.vue'),
    CampanhasAgendadas: () => import('@/modules/campanhas/whatsapp/views/components/CampanhasAgendadas.vue'),
    Disparadores: () => import('@/modules/campanhas/whatsapp/views/components/Disparadores.vue'),
    Segmentos: () => import('@/modules/campanhas/whatsapp/views/components/Segmentos.vue'),
    ProductsConfiguration: () => import('@/modules/campanhas/views/components/edit/ProductsConfiguration.vue'),
    OfferScheduleCard: () => import('@/modules/campanhas/views/components/edit/OfferScheduleCard.vue'),
    TemplateMessageModal,
    MeasuringAndRecurrency: () => import('@/modules/campanhas/views/components/edit/MeasuringAndRecurrency.vue'),
    MessageVariables: () => import('@/modules/campanhas/views/components/edit/MessageVariables.vue'),
    UnitsConfiguration: () => import('@/modules/campanhas/views/components/edit/UnitsConfiguration.vue'),
  },
  filters: {
    zeroWhenEmpty(value) {
      if (!value) return 0
      return value
    },
  },
  mixins: [offerScheduleCampaign, loadBenefitCampaignMixin],
  props: {
    newCampaign: Boolean,
  },
  data: () => ({
    campanhaId: undefined,
    initialLoadingContacts: true,
    selectedTemplate: {},
    totalSenderContacts: {
      total: 0,
      community_total: 0,
      loyalty: 0,
      non_loyalty: 0,
    },
    chosenSegments: [],
    targetingMode: 'ALL',
    chosenSenders: [],
    fileProperties: {},
    showAllProducts: false,
    availableMessagesLoading: false,
    availableMessages: 0,
    hasFile: false,
    tryingToSaveAsDraft: false,
    clientsFromSegments: 0,
    loading: {
      scheduled: {
        submit: false,
        disable: false,
      },
      draft: {
        submit: false,
        submitAsDraft: false,
      },
    },
    campanha: {
      title: '',
      description: '',
      products: [],
      segments: [],
      senders: [],
      initial_date: '',
      final_date: '',
      template_id: '',
      message: {
        text: '',
        send_date: '',
        send_time: '',
        attachment: {
          data_url: '',
          thumbnail_url: '',
          mimetype: '',
          filename: '',
        },
      },
      offers_schedule_id: '',
    },
  }),
  computed: {
    ...mapGetters({ quickAction: 'getQuickAction' }),
    messageVariablesDisabled() {
      return this.isExternalWhatsappProvider && this.targetingMode === 'ALL'
    },
    hasOptoutMessage() {
      return !this.messageVariablesDisabled
    },
    messageVariablesTooltipText() {
      if (!this.messageVariablesDisabled) return ''
      return 'Campanhas massivas no modelo comunidade não podem conter variáveis.'
    },
    isExternalWhatsappProvider() {
      return this.$getAllowedModules()['external_whatsapp_provider']
    },
    minSendTime() {
      if (this.isExternalWhatsappProvider) return '06:00'
      return ''
    },
    maxSendTime() {
      if (this.isExternalWhatsappProvider) return '21:30'
      return ''
    },
    pageTitle() {
      if (this.newCampaign) return this.$t('campanhas.nova_campanha')
      else return this.$t('campanhas.editar_campanha')
    },
    errorTitle() {
      if (!this.$v.campanha.title) return ''
      if (this.$v.campanha.title.$error) {
        if (!this.$v.campanha.title.required) return 'Dê um nome para esta campanha.'
        else if (!this.$v.campanha.title.minLength) return 'O título possui menos de 2 caracteres.'
        else if (!this.$v.campanha.title.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      } else return ''
      return ''
    },
    errorDescription() {
      if (!this.$v.campanha.description) return ''
      if (this.$v.campanha.description.$error) {
        if (!this.$v.campanha.description.required) return 'Informe detalhes para melhor identificação da campanha.'
        else if (!this.$v.campanha.description.minLength) return 'A descrição possui menos de 2 caracteres.'
        else if (!this.$v.campanha.description.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      } else return ''
      return ''
    },
    errorText() {
      if (!this.$v.campanha.message || !this.$v.campanha.message.text) return ''
      if (this.$v.campanha.message.text.$error) {
        if (!this.$v.campanha.message.text.required) return 'Adicione uma mensagem para esta campanha.'
        else if (!this.$v.campanha.message.text.maxLength) return 'O texto da mensagem excedeu 1000 caracteres.'
        else if (!this.$v.campanha.message.text.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      if (this.$refs.whatsappMessagePreview?.hasVariableErrors) return 'O texto da mensagem contém variáveis inválidas.'
      return ''
    },
  },
  apollo: {
    totalSenderContacts: {
      query: QUERY_NUMBER_OF_CONTACTS,
      deep: true,
      notifyOnNetworkStatusChange: true,
      variables() {
        return {
          active: true,
          senders: this.chosenSenders,
        }
      },
      skip() {
        if (!this.chosenSenders || !this.chosenSenders.length) return true
        return false
      },
      update({ getNumberOfContacts }) {
        if (!getNumberOfContacts) return {}
        this.initialLoadingContacts = false
        return getNumberOfContacts
      },
      fetchPolicy: 'no-cache',
    },
    campanha: {
      query: QUERY_GET_CAMPAIGN_EDIT_BY_ID,
      notifyOnNetworkStatusChange: true,
      context() {
        return {
          uri: this.$microservicesUrls['campaigns'],
        }
      },
      update({ campaign }) {
        let newCampaign = cloneDeep(campaign)

        if (!newCampaign) return this.campanha
        delete newCampaign.__typename
        if (!newCampaign.products) newCampaign.products = []

        this.chosenSenders = newCampaign.senders.map((item) => item.number)
        this.chosenSegments = newCampaign.segments
        this.targetingMode = newCampaign.targeting_mode

        if (!this.targetingMode) {
          // use default
          this.targetingMode = this.chosenSegments && this.chosenSegments.length > 0 ? 'SEGMENTED' : 'ALL'
        }

        if (newCampaign.message) {
          delete newCampaign.message.__typename
          if (newCampaign.message.attachment) {
            delete newCampaign.message.attachment.__typename
          }
        }

        if (newCampaign.segments) {
          newCampaign.segments = newCampaign.segments.map((segment) => {
            return {
              ...segment,
              updating: false,
            }
          })
        }

        this.fileProperties = newCampaign.message && newCampaign.message.attachment

        if (newCampaign?.offers_schedule && Object.entries(newCampaign.offers_schedule).length) {
          newCampaign = { ...newCampaign, offers_schedule_id: newCampaign.offers_schedule._id }
          this.offerSchedule = newCampaign.offers_schedule
        } else {
          newCampaign = { ...newCampaign, offers_schedule_id: '' }
          this.offerSchedule = {}
        }

        if (newCampaign.units?.length) {
          newCampaign.units = newCampaign.units.map((unit) => unit.id_erp ?? unit)
        }

        delete newCampaign.offers_schedule

        return newCampaign
      },
      variables() {
        return {
          id: this.campanhaId,
        }
      },
      skip() {
        if (!this.campanhaId) return true
        return false
      },
      fetchPolicy: 'no-cache',
    },
  },
  watch: {
    fileProperties(value) {
      if (value && Object.keys(value).length) {
        this.hasFile = true
      } else {
        this.hasFile = false
      }
    },
    chosenSenders(value) {
      if (!value || !value.length) {
        this.totalSenderContacts = {
          total: 0,
          community_total: 0,
          loyalty: 0,
          non_loyalty: 0,
        }
      }
    },
    selectedTemplate() {
      this.campanha.template_id = this.selectedTemplate._id
      this.campanha.message.text = this.selectedTemplate.message
    },
  },
  async mounted() {
    this.campanhaId = this.$route.params.id
    this.prebuildAutoCampaign()

    await this.loadBenefit({
      assignFieldsFn: ({ benefit, parsedSendDate, parsedFinalDate }) => {
        this.campanha.title = benefit.title
        this.campanha.description = benefit.description
        this.campanha.initial_date = parsedSendDate
        this.campanha.final_date = parsedFinalDate
        this.campanha.message.send_date = parsedSendDate

        const mappedSegments = (benefit.segmentsData || []).map((s) => ({
          ...s,
          clients_qty: s.clientsQty,
          clients_refreshed_at: s.clientsRefreshedAt,
          updating: false,
        }))

        this.campanha.segments = mappedSegments
        this.chosenSegments = mappedSegments

        if (mappedSegments.length) {
          this.targetingMode = 'SEGMENTED'
        }
      },
    })
  },
  methods: {
    ...mapActions(['unsetQuickAction']),

    cancel() {
      this.$confirm({ message: 'Todas as alterações serão descartadas.', confirmText: 'Ok', cancelText: 'Cancelar' })
        .then(() => {
          this.returnToHome()
        })
        .catch(() => {})
    },

    confirmDisable({ loader }) {
      this.$confirm({
        title: 'Desativar campanha',
        message: 'Deseja desativar esta campanha agendada?',
        confirmText: 'Desativar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
      })
        .then(() => {
          this.submit({ isDraft: true, loader: loader })
        })
        .catch(() => {})
    },

    removeProduct(index) {
      this.campanha.products.splice(index, 1)
    },

    async remove({ loader }) {
      try {
        this.$confirm({
          title: 'Remover rascunho',
          message: 'Tem certeza que deseja remover este rascunho?',
          confirmText: 'Remover',
          confirmColor: 'vermelho-d20',
          cancelText: 'Cancelar',
        })
          .then(async () => {
            this.$wait.start(loader)

            await this.$apollo.mutate({
              mutation: MUTATION_DELETE_CAMPAIGN,
              variables: {
                id: this.campanha._id,
              },
              context: {
                uri: this.$microservicesUrls['campaigns'],
              },
            })

            this.$wait.end(loader)

            this.$snackbar({ message: 'Rascunho apagado.', snackbarColor: 'success' })
            this.returnToHome()
          })
          .catch(() => {})
      } catch (error) {}
    },

    async submit({ isDraft, loader }) {
      try {
        this.tryingToSaveAsDraft = isDraft
        this.$v.$reset()
        this.$v.$touch()

        // Validate senders
        this.$refs.disparadores.validate()

        if (this.$v.$error || this.$refs.disparadores.$v.$error) {
          this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
          this.$nextTick(() => {
            this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200 })
          })

          return
        }
        if (this.$refs.whatsappMessagePreview?.hasVariableErrors && this.messageVariablesDisabled) {
          const confirmed = await this.$confirm({
            title: 'Variáveis inválidas',
            message: 'Existem variáveis inválidas na mensagem. Campanhas de WhatsApp massivas não possuem variáveis. Deseja continuar?',
            confirmText: 'Continuar',
            confirmColor: 'primary',
            cancelText: 'Cancelar',
          })
            .then(() => true)
            .catch(() => false)
          if (!confirmed) return
        }
        this.$wait.start(loader)
        const campaignToSave = cloneDeep(this.campanha)
        delete campaignToSave.status

        campaignToSave.segments = this.chosenSegments.map((obj) => obj._id)
        campaignToSave.targeting_mode = this.targetingMode
        campaignToSave.senders = this.chosenSenders
        campaignToSave.products = campaignToSave.products.map((obj) => obj.sku)
        if (this.fileProperties && Object.keys(this.fileProperties).length && this.hasFile) {
          campaignToSave.message = { ...campaignToSave.message, attachment: this.fileProperties }
        } else {
          campaignToSave.message.attachment = null
        }

        if (isDraft) {
          await this.$apollo.mutate({
            mutation: MUTATION_UPSERT_DRAFT_CAMPAIGN,
            variables: {
              data: campaignToSave,
            },
            context: {
              uri: this.$microservicesUrls['campaigns'],
            },
          })

          Swal.fire({
            text: this.campanha.status === 'SCHEDULED' ? 'Campanha desativada' : 'Rascunho salvo',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
          this.$wait.end(loader)
          this.returnToHome()
        } else {
          await this.$apollo.mutate({
            mutation: MUTATION_UPSERT_CAMPAIGN,
            variables: {
              data: campaignToSave,
            },
            context: {
              uri: this.$microservicesUrls['campaigns'],
            },
          })

          Swal.fire({
            text: 'Sua campanha foi agendada',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
          this.$wait.end(loader)
          this.returnToHome()
        }
      } catch (error) {
        Swal.fire({
          text: 'Erro ao salvar campanha',
          icon: 'error',
          showConfirmButton: false,
          timer: 1000,
          customClass: {
            content: 'content-class',
          },
        })
      }
    },

    returnToHome() {
      this.$router.push('/campanhas/whatsapp').catch(() => {})
    },

    scrollMeTo(refName) {
      window.scrollTo(0, this.$refs[refName].offsetTop)
    },

    async prebuildAutoCampaign() {
      if (!this.getIsQuickAction() || !this.quickAction?.segmentation) {
        return
      }

      this.campanha.title = this.quickAction.segmentation.title
      this.campanha.description = this.quickAction.segmentation.description

      this.chosenSegments.push(this.quickAction.segmentation.segment)
      this.targetingMode = 'SEGMENTED'

      this.unsetQuickAction()
    },

    cleanInputs() {
      this.campanha.message.send_time = ''
      this.campanha.initial_date = ''
      this.campanha.final_date = ''
    },
  },
  validations() {
    if (this.tryingToSaveAsDraft) {
      return {
        campanha: {
          title: { required, minLength: minLength(2), notOnlySpace },
          message: {
            text: { maxLength: maxLength(1000) },
          },
        },
      }
    } else {
      const titleValidator = { required, minLength: minLength(2), notOnlySpace }
      const descriptionValidator = { required, minLength: minLength(2), notOnlySpace }
      const initialDateValidator = { required }
      const finalDateValidator = { required }

      let messageValidator = {}

      if (this.hasFile) {
        messageValidator = {
          text: {
            maxLength: maxLength(1000),
            notOnlySpace,
          },
          send_date: { required, isFuture: isFuture },
          send_time: {
            required,
            timeIsFuture: function (value) {
              return timeIsFuture(this.campanha.message.send_date, value)
            },
          },
        }
      } else {
        messageValidator = {
          text: {
            required,
            maxLength: maxLength(1000),
            notOnlySpace,
          },
          send_date: { required, isFuture: isFuture },
          send_time: {
            required,
            timeIsFuture: function (value) {
              return timeIsFuture(this.campanha.message.send_date, value)
            },
          },
        }
      }
      return {
        campanha: {
          title: titleValidator,
          description: descriptionValidator,
          message: messageValidator,
          initial_date: initialDateValidator,
          final_date: finalDateValidator,
          units: {
            required,
            minLength: minLength(1),
          },
        },
      }
    }
  },
}
</script>

<style lang="scss">
.alteracao-whatsapp {
  .card__text {
    height: 100% !important;
  }
  .disabled-chip {
    cursor: unset;
    pointer-events: none;
    user-select: none;
  }
  .number-of-clients {
    min-height: 38px;
    height: 38px;
    p {
      font-size: 28px;
    }
    .whatsapp {
      font-weight: bold;
      color: $marca-0-l40;
      &.zero {
        color: $vermelho-l40;
      }
    }
  }
  .whatsapp-regular {
    font-size: 18px;
    letter-spacing: 0.3px;
    color: $cinza-d20;
  }
  .whatsapp-highlighted {
    font-size: 36px;
    letter-spacing: 0.6px;
    color: $cinza-d20;
  }
  .whatsapp-section-title {
    font-size: 16px;
    letter-spacing: 0.27px;
    color: $cinza-d20;
  }
  .sender-name {
    font-size: 12px;
  }
  .sender-number {
    font-size: 15px;
    font-weight: bold;
  }
  .sender-status {
    letter-spacing: 0.24px;
    font-size: 15px;
  }
  .label {
    font-size: 11px;
    letter-spacing: 0.22px;
    color: $cinza-d20;
  }
  .label-box {
    min-height: 24px;

    span {
      display: block;
      line-height: 2 !important;
      margin-bottom: 0;
      text-align: right;
      opacity: 0.8;
      font-size: 11px;
      font-weight: 500;
      line-height: 1.18;
      letter-spacing: 0.18px;
    }
  }
  .hint-text {
    font-size: 12px;
    letter-spacing: 0.23px;
    color: $cinza-d10;
  }

  .message-preview-title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.33px;
    color: $cinza-d20;
  }

  .textarea {
    textarea {
      padding-right: 0px;
      margin-bottom: 10px;
      margin-right: 2px;
    }
  }

  .textarea-disabled {
    .v-input {
      background: $cinza-l90;
    }
    textarea {
      text-align: center;
    }
    .v-input__append-inner {
      display: none;
    }
  }
}
.content-class {
  font-family: 'Lato', sans-serif !important;
}
</style>
